var render = function render(){var _vm=this,_c=_vm._self._c;return _c('QDynamicSubmenu',{attrs:{"default-title":_vm.title,"default-buttons":_vm.buttons,"titlelink":_vm.titlelink,"submenu":_vm.submenu}})
}
var staticRenderFns = []

export { render, staticRenderFns }